import './conditionParameter.scss'

export class ConditionParameter {

    constructor($scope, $log) {
        this.$scope = $scope;
        this.$log = $log;
        $log.debug('ConditionParameterComponent is mounting')
    }

    $onInit() {
        let condition = this.condition;
        let parameterName = this.parameterName;
        this.$scope.parameter = condition.conditionParameters.find(param => param.type === parameterName);
        this.$log.debug('ConditionParameterComponent has mounted')
    }

    static instance = {
        controller: ['$scope', '$log', ConditionParameter],
        template: require('./conditionParameter.html'),
        bindings: {
            condition: '<',
            parameterName: '@'
        }
    }
}